export default "__VITE_ASSET__Cg3tDqxH__"